import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/{-$locale}/onboarding/_wrapper')({
  component: RouteComponent,
  validateSearch: z.object({
    organizationId: z.string().trim().nonempty().optional(),
    redirect: z.string().trim().nonempty().optional()
  })
});

function RouteComponent() {
  return <Outlet />;
}
